import { render, staticRenderFns } from "./CustomersCorporateWalletBanner.vue?vue&type=template&id=9f1bccf6&scoped=true"
import script from "./CustomersCorporateWalletBanner.vue?vue&type=script&lang=js"
export * from "./CustomersCorporateWalletBanner.vue?vue&type=script&lang=js"
import style0 from "./CustomersCorporateWalletBanner.vue?vue&type=style&index=0&id=9f1bccf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1bccf6",
  null
  
)

export default component.exports